import { FileUploadDTO } from "api/FilesApi";
import { easasAlert } from "components/fragments/easas-global-fragment/EasasGlobalAlerts";
import { SIMPLE_IDENTIFIER_REGEX } from "utils/regex";

export interface FileDialogProps {
  visible: boolean;
  setVisible: (v: boolean) => void;
  currentFile?: FileUploadDTO;
  setCurrentFile: (f: FileUploadDTO) => void;
}

export function validateTags(tags: string[]) {
  let hasInvalidTag = false;
  tags.forEach(tag => {
    if (!tag.match(SIMPLE_IDENTIFIER_REGEX) && !hasInvalidTag) {
      easasAlert({
        summary: "Tags can only contain letters and numbers",
        severity: "warn",
      });
      hasInvalidTag = true;
    }
  });
}
